export default "__VITE_ASSET__B6BEJ_q9__"